import { Button, Heading } from "@ariakit/react";
import { useCurrentUser } from "@indietabletop/appkit";
import { interactiveText } from "@indietabletop/appkit/common.css.ts";
import { Link } from "wouter";
import { obfuscated } from "../../common/common.css.ts";
import { database } from "../../database.ts";
import { hrefs } from "../../hrefs.ts";
import { useCheckAccessResult } from "../CheckAccess/context.ts";
import { useGangContext } from "../GangPage/useGang.ts";
import { note } from "./style.css.ts";

export function PremiumContentNote() {
  const currentUser = useCurrentUser();
  const [result] = useCheckAccessResult();

  // If currentUser exists, it means the user is logged in. In that case, we
  // wait for the check access request to fully fail before showing the note
  // to avoid a flash of irrelevant content for users that have access. If
  // there is no currentUser, we have an anonymous user which means we can
  // safely show the note immediately.
  if (currentUser && !result.isFailure) {
    return null;
  }

  return (
    <div className={note.container}>
      <Heading className={note.heading}>Oi! Why the squiggly lines?</Heading>

      <p className={note.info}>
        Some content is only available if you own Space Gits.{" "}
        <Link href={hrefs.buy()} className={interactiveText}>
          Buy now
        </Link>
        , or learn how to{" "}
        <Link
          href="~/docs/help/accessing-owned-content"
          className={interactiveText}
        >
          get access
        </Link>{" "}
        if you&apos;ve purchased it previously. Otherwise, you can still use the
        app, but you will see <span className={obfuscated()}>squgglies</span> in
        some places.
      </p>
    </div>
  );
}

export function CheatModeNote() {
  const { gang } = useGangContext();

  return (
    <div className={note.container}>
      <Heading className={note.heading}>Cheat mode enabled!</Heading>

      <p className={note.info}>
        {gang.mode.isCampaignMode
          ? "Gang can be changed with minimal constraints and without affecting your stash balance. "
          : "Gang can be changed ingoring the usual build mode constraints. "}
        <Button
          className={interactiveText}
          onClick={() => {
            const nextMode = gang.mode.setCheatModeActive(false);
            return database.gangs.updateOne(nextMode.gang.data);
          }}
        >
          Disable cheat mode
        </Button>
        .
      </p>
    </div>
  );
}
